import React from 'react';
import { useInfoCollectionFormCtx } from 'pages/Main/QRScreens/hooks/useInfoCollectionFormCtx';
import { FormTextField } from 'components/__v5__/FormTextField';

export const Company: React.FC = () => {
  const { control } = useInfoCollectionFormCtx();
  return (
    <FormTextField
      name="company"
      control={control}
      label="Company"
      placeholder="Company"
      showError
    />
  );
};
